const TAG_CLASS_MAP: Record<string, string> = {
  p: 'content-tags__p',
  h1: 'content-tags__h1',
  h2: 'content-tags__h2',
  h3: 'content-tags__h3',
  h4: 'content-tags__h4',
  h5: 'content-tags__h5',
  a: 'content-tags__p',
  img: 'content-tags__img',
  ul: 'content-tags__ul',
  ol: 'content-tags__ol',
  li: 'content-tags__li',
};

const CONTENT_TAGS_CLASS_PREFIX = 'content-tags__';

function hasContentTagsClass(element: Element): boolean {
  return Array.from(element.classList).some((className) =>
    className.startsWith(CONTENT_TAGS_CLASS_PREFIX),
  );
}

function appendClass(element: Element, className: string): void {
  if (!element.classList.contains(className)) {
    element.classList.add(className);
  }
}

function wrapVideos(root: ParentNode): void {
  root.querySelectorAll('video').forEach((video) => {
    appendClass(video, 'content-tags__video-player');

    const parent = video.parentElement;
    if (!parent || parent.classList.contains('content-tags__video')) {
      return;
    }

    const wrapper = video.ownerDocument.createElement('div');
    wrapper.className = 'content-tags__video';
    parent.insertBefore(wrapper, video);
    wrapper.appendChild(video);
  });
}

function enrichElements(root: ParentNode): void {
  root.querySelectorAll('*').forEach((element) => {
    const tag = element.tagName.toLowerCase();

    if (tag === 'video') {
      return;
    }

    const mappedClass = TAG_CLASS_MAP[tag];
    if (mappedClass) {
      appendClass(element, mappedClass);
      return;
    }

    if (tag === 'div' && !hasContentTagsClass(element)) {
      appendClass(element, 'content-tags__p');
    }
  });
}

export function enrichContentTagsHtml(html: string): string {
  const trimmed = html.trim();
  if (!trimmed) {
    return '';
  }

  const doc = new DOMParser().parseFromString(trimmed, 'text/html');
  const { body } = doc;

  const hasElementChildren = Array.from(body.childNodes).some(
    (node) => node.nodeType === Node.ELEMENT_NODE,
  );

  if (!hasElementChildren && body.textContent?.trim()) {
    const paragraph = doc.createElement('p');
    paragraph.className = 'content-tags__p';
    paragraph.textContent = body.textContent.trim();
    body.textContent = '';
    body.appendChild(paragraph);
  }

  wrapVideos(body);
  enrichElements(body);

  return body.innerHTML;
}
